import * as breakpoints from 'constants/breakpoints';

export const THUMBNAIL_WIDTH_MAPPING = {
  [breakpoints.EXTRA_LARGE_DEVICE_WIDTH]: 170,
  [breakpoints.LARGE_DEVICE_WIDTH]: 208,
  [breakpoints.MEDIUM_DEVICE_WIDTH]: 208,
  [breakpoints.SMALL_DEVICE_WIDTH]: 170,
  default: 208,
};
